import { addNotification } from '../../../../actions/notificationActions';
import store from '../../../../redux/store';

class Notify {
  /**
   * Dispatches a notification to the store.
   * @param {string} type - The notification type (e.g., 'success', 'danger', 'info').
   * @param {string} text - The notification message text.
   */
  #send(type, text) {
    store.dispatch(addNotification({ type, text }));
  }

  /**
   * Dispatches a success notification to the store.
   * @param {string} text - The notification message text.
   * @param {any|null} additionalInfo - Optional additional info for logging.
   */
  success(text, additionalInfo = null) {
    console.info('success:', text, additionalInfo);
    this.#send('success', text);
  }

  /**
   * Dispatches an error notification to the store.
   * @param {string} text - The notification message text.
   * @param {Error|null} error - An optional error object for logging.
   * @param {any|null} additionalInfo - Optional additional info for logging.
   */
  error(text, error = null, additionalInfo = null) {
    console.error('error:', text, error, additionalInfo);
    this.#send('danger', text);
  }

  /**
   * Dispatches an info notification to the store.
   * @param {string} text - The notification message text.
   */
  info(text) {
    console.info('info:', text);
    this.#send('info', text);
  }
}

const instance = new Notify();

export default instance;
